<template>
  <CoreNavigationDrawerListItem
    v-for="generic in genericFolders"
    :key="generic.id"
    :data-test-id="`box-navigation-generic-${generic.name}`"
    exact
    :title="generic.displayName"
    :to="{
      name: 'organization-types-type-boxes-box-files-node',
      params: {
        node: generic.nodeId,
      },
    }"
  >
    <template #icon>
      <v-icon v-tooltip:top="generic.displayName">
        <BoxGenericsIcon :generic-folder="generic" size="18" />
      </v-icon>
    </template>
  </CoreNavigationDrawerListItem>
</template>

<script lang="ts" setup>
import BoxGenericsIcon from '@/components/box/generics/BoxGenericsIcon.vue'
import CoreNavigationDrawerListItem from '@/components/core/CoreNavigationDrawerListItem.vue'
import type { GenericFolder } from '@deepcloud/api-deep-box'

defineProps({
  genericFolders: {
    type: Array as PropType<GenericFolder[]>,
    default: () => [],
  },
})
</script>
